<ng-container *ngIf="isLoading; else loadedState">
    <div class="loading">
        <app-loading-spinner></app-loading-spinner>
    </div>
</ng-container>

<ng-template #loadedState>
    <ng-container *ngIf="itemTemplate && hasItems; else emptyState">
        <ng-container *ngIf="useVirtualScroll; else nonVirtual">
            <virtual-scroller #vs
                              class="scroller"
                              [items]="items"
                              (vsEnd)="onEnd($event)">
                <ng-container *ngFor="let item of vs.viewPortItems; let i = index;">
                    <div class="item">
                        <ng-container
                            *ngTemplateOutlet="itemTemplate.template; context: { $implicit: item, index: i }">
                        </ng-container>
                    </div>
                </ng-container>
                <div class="body-after" *ngIf="hasBodyAfter">
                    <ng-container *ngIf="bodyAfterTemplates?.first"
                                  [ngTemplateOutlet]="bodyAfterTemplates.first.template">
                    </ng-container>
                </div>
            </virtual-scroller>
        </ng-container>
        <ng-template #nonVirtual>
            <div class="scroller-nonVirtual">
                <div class="item" *ngFor="let item of items; let i = index;">
                    <ng-container
                        *ngTemplateOutlet="itemTemplate.template; context: { $implicit: item, index: i }">
                    </ng-container>
                </div>
                <div class="body-after" *ngIf="hasBodyAfter">
                    <ng-container *ngIf="bodyAfterTemplates?.first"
                                  [ngTemplateOutlet]="bodyAfterTemplates.first.template">
                    </ng-container>
                </div>
            </div>
        </ng-template>
    </ng-container>

    <ng-template #emptyState>
        <ng-container *ngIf="itemTemplate; else missingTemplate">
            <ng-container *ngIf="hasEmptyState; else defaultEmpty">
                <ng-content select="[versatileListEmpty]"></ng-content>
            </ng-container>
            <ng-template #defaultEmpty>
                <div class="empty">
                    {{ "generic.noItems" | translate }}
                </div>
            </ng-template>
        </ng-container>

        <div class="body-after" *ngIf="hasBodyAfter">
            <ng-container *ngIf="bodyAfterTemplates?.first"
                          [ngTemplateOutlet]="bodyAfterTemplates.first.template">
            </ng-container>
        </div>
    </ng-template>

    <ng-template #missingTemplate>
        <div class="missing-template">
            Provide a template using <ng-container>&lt;ng-template versatileListItem&gt;</ng-container>.
        </div>
    </ng-template>

</ng-template>

